<template>
  <div id="myHistory">
    <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" ref="loadmore" v-show="!noDataList"
                 :bottom-all-loaded="true" :autoFill="false" :bottomAllLoaded="allLoaded"
    >
      <ul id="uls">
        <li v-for="(item, index) in dataList" :keyss="String(index)" class="history-item border-1px">
          <span :keyss="String(index)">{{item.privateName}}</span>
          <i :keyss="String(index)" class="iconfont icon-danju-xinjian right-icon"></i>
        </li>
      </ul>
    </mt-loadmore>
    <div class="dataListOver" v-show="dataListOver">——————&nbsp;&nbsp;加载完成&nbsp;&nbsp;——————</div>
    <div class="noDataList" v-show="noDataList">——————&nbsp;&nbsp;您还没有历史锅底记录&nbsp;&nbsp;——————</div>
  </div>
</template>
<script>
  import {Loadmore, Indicator} from 'mint-ui';
  import ajax from '../../../pub/utils/ajaxUtils.js'
  import mainUtils from '../../../pub/utils/mainUtils'

  export default {
    methods: {
      historyItemTransmit(e) {
        let i = e.target.getAttribute('keyss');
        let _string = JSON.stringify(this.dataList[i]);
        return WebViewJavascriptBridge.normalPots(_string);
      },
      loadTop() {
        this.removeClick();
        this.pageNum = 1;
        this.dataListOver = false;
        this.allLoaded = false;
        this.getList(this.$refs.loadmore.onTopLoaded);
      },
      loadBottom() {
        this.removeClick();
        this.pageNum++;
        this.getList(this.$refs.loadmore.onBottomLoaded);
      },
      getList(cb) {
        if (this.pageNum === 1) {
          let params = {
            token: this.propsInfo.token,
            shopId: this.propsInfo.shopId,
            memberId: this.propsInfo.memberId,
            companyId: this.propsInfo.companyId,
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            ip: this.propsInfo.ip,
            country: this.propsInfo.country
          };
          ajax.postJson(`http://${this.propsInfo.ip}:8020/shop/dish/historyPot`, params,
            data => {
              if (data.result === 200) {
                this.allData = data.obj.dishList;
                let len = this.allData.length;
                if (len === 0) this.noDataList = true;
                if (len <= 10) {
                  this.allLoaded = true;
                  this.dataList = this.allData;
                }
                else this.dataList = this.allData.splice(0, 10);
                if (cb) cb();
              }
            }
          )
        }
        else {
          if (this.allData.length === 0) {
            this.allLoaded = true;
            this.dataListOver = true;
            if (cb) cb();
          }
          else setTimeout(() => {
            this.dataList = this.dataList.concat(this.allData.splice(0, 10));
            if (cb) cb();
          }, 500);
        }
      },
      removeClick() {
        let uls = document.getElementById('uls');
        uls.removeEventListener('click', this.historyItemTransmit);
      },
      handleTouchEnd() {
        this.$nextTick(() => {
          let uls = document.getElementById('uls');
          setTimeout(() => {
            uls.addEventListener('click', this.historyItemTransmit);
          }, 100)
        })
      },
    },
    data() {
      return {
        wrapperHeight: 0,
        dataListOver: false,// 请求完毕
        noDataList: false,// 没有数据
        pageSize: 999999,// 条数
        pageNum: 1,// 页码
        propsInfo: {
          token: '',
          shopId: '',
          phone: '',// 私人定制 -- 手机号 历史锅底 -- 会员ID
          memberId: '',// 私人定制 -- 手机号 历史锅底 -- 会员ID
          companyId: '',
          ip: '',
        },
        dataList: [],
        allData: [],
        allLoaded: false,
      }
    },
    components: {Loadmore, Indicator},
    created() {
      this.$nextTick(() => {
        let uls = document.getElementById('uls');
        uls.addEventListener('click', this.historyItemTransmit);
        uls.addEventListener('touchmove', this.removeClick);
        uls.addEventListener('touchend', this.handleTouchEnd);
        this.propsInfo = Object.assign(this.propsInfo, mainUtils.pathName());
        this.getList();
      })
    },
  }
</script>
<style lang="stylus" scoped>
  @import "../../../assets/css/func.styl"
  #myHistory
    box-sizing: border-box
    .list-chunk
      overflow: scroll;
    ul
      margin: 0 .4rem
    .history-item
      display: flex
      flex-direction: row
      padding-left: .08rem
      bb-1px(#f3f3f3)
      line-height 1.8rem
      font-size: .34rem
      span
        flex 1
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
      .right-icon
        font-size .34rem
        color: #ff9800
    .dataListOver
      text-align center
      line-height .9rem
      font-size: .34rem
      color: #e3e3e3
    .noDataList
      text-align center
      line-height 1.8rem
      font-size: .34rem
</style>


// WEBPACK FOOTER //
// src/components/taste/history/history.vue